import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import RequiresRole from 'flaivy-react/components/RequiresRole';

import {
  Dropdown,
  DropdownToggle,
  DropdownItem,
  NavLink,
  DropdownMenu,
  Navbar,
  Nav,
  NavItem,
  NavbarToggler,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from 'reactstrap';
import { ChangeActiveOrganizationForm } from './action-forms/user';
import { ToastContainer } from 'react-toastify';
import PropTypes from 'prop-types';
import Avatar from './Avatar';
import AlertBell from './alert/AlertBell';
import {
  logout as _logout,
  changeActiveOrganization as _changeActiveOrganization,
  endImpersonation as _endImpersonation,
} from '../shared/actions/auth.actions';
import { toggleSidebar as _toggleSidebar } from '../shared/actions/navigation.actions';

class Header extends React.Component {
  static get propTypes() {
    return {
      authentication: PropTypes.object.isRequired,
    };
  }

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.state = {
      dropdownIsOpen: false,
      isModalOpen: false,
    };
  }

  onLogout(event) {
    const { logout } = this.props;
    event.preventDefault();
    logout();
  }

  toggleSidebar(event) {
    const { toggleSidebar } = this.props;
    event.preventDefault();
    toggleSidebar();
  }

  toggleDropdown() {
    this.setState({
      dropdownIsOpen: !this.state.dropdownIsOpen,
    });
  }
  toggleModal() {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
  }

  render() {
    const {
      authentication: {
        sessionUser: { firstName, lastName, organization },
      },
      changeActiveOrganization,
      endImpersonation,
    } = this.props;

    const { dropdownIsOpen } = this.state;

    const { authentication } = this.props;

    const impersonating = _.get(
      authentication.sessionUser,
      'impersonation',
      false,
    );

    return (
      <>
        <Navbar light className="navbar-custom">
          <Nav className="mr-auto">
            <NavbarToggler
              onClick={this.toggleSidebar}
              className="me-2 d-xs-block d-sm-block d-md-block d-lg-block d-xl-none"
            />
            <ToastContainer position="bottom-right" autoClose={3000} />
          </Nav>
          <Nav>
            <NavItem>
              <NavLink className="p-0 px-2 pt-3">
                <AlertBell />
              </NavLink>
            </NavItem>

            <Dropdown
              nav
              isNavbar
              isOpen={dropdownIsOpen}
              toggle={this.toggleDropdown}
            >
              <DropdownToggle
                nav
                caret
                className="nav-link dropdown-toggle nav-user arrow-none"
              >
                <span
                  className="account-user-avatar"
                  style={{ marginRight: '10px' }}
                >
                  <Avatar />
                </span>
                <span>
                  <span
                    className="account-user-name text-muted"
                    style={{ marginTop: '10px' }}
                  >
                    {impersonating
                      ? organization.name
                      : `${firstName} ${lastName}`}
                  </span>
                </span>
              </DropdownToggle>
              <DropdownMenu end>
                <RequiresRole requiredRoles={['super']}>
                  <DropdownItem tag="div" toggle={false}>
                    <Button color="link" onClick={this.toggleModal}>
                      Byt organization
                    </Button>
                  </DropdownItem>
                </RequiresRole>
                {impersonating && (
                  <>
                    <DropdownItem tag="div">
                      <NavLink onClick={() => endImpersonation()}>
                        Byt till min organization
                      </NavLink>
                    </DropdownItem>
                    <DropdownItem divider />
                  </>
                )}
                <DropdownItem>
                  <NavLink onClick={this.onLogout}>Logout</NavLink>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Nav>
        </Navbar>
        <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>
            {'Byt organization'}
          </ModalHeader>
          <ModalBody>
            <ChangeActiveOrganizationForm
              onSubmit={(params, result) => {
                changeActiveOrganization(params, result);
              }}
              modal={true}
            />
          </ModalBody>
        </Modal>
      </>
    );
  }
}

function mapStateToProps({ authentication }) {
  return { authentication };
}

const mapDispatchToProps = {
  changeActiveOrganization: _changeActiveOrganization,
  logout: _logout,
  toggleSidebar: _toggleSidebar,
  endImpersonation: _endImpersonation,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
